import { render, staticRenderFns } from "./UserHeader.vue?vue&type=template&id=d46ce7cc&lang=pug&"
import script from "./UserHeader.vue?vue&type=script&lang=js&"
export * from "./UserHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports